/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LexplusAufgabeDetailDto } from '../../models/lexplus-aufgabe-detail-dto';

export interface AufgabenControllerFindOneByIdV1$Params {
  id: number;
}

export function aufgabenControllerFindOneByIdV1(http: HttpClient, rootUrl: string, params: AufgabenControllerFindOneByIdV1$Params, context?: HttpContext): Observable<StrictHttpResponse<LexplusAufgabeDetailDto>> {
  const rb = new RequestBuilder(rootUrl, aufgabenControllerFindOneByIdV1.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<LexplusAufgabeDetailDto>;
    })
  );
}

aufgabenControllerFindOneByIdV1.PATH = '/v1/aufgaben/{id}';
